module.exports = "/images/london-25.jpg";